var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"column",attrs:{"src":"https://templatesmail.digitalchat.com.br","frameborder":"0"}})
}
var staticRenderFns = []

export { render, staticRenderFns }